<s1-input-select [control]="control" [itemsList]="operatori" [label]="'operatori.fields.operatore'" [readonly]="readonly"></s1-input-select>